module.exports = __webpack_public_path__ + "static/media/plus-thin.18499000.svg";